import React from 'react'
import '../Style/Manage_Site_UserProf.css'
import Profile from '../Profile_Pictures/1662741205554.jpg'

function User_Profile_Com() {
  return (
    <>
        <div className='user-prof-container'>
            <div className='profile-picture' style={{ backgroundImage: `url(${Profile})` }}></div>
            <div className='user-name'>LingoMan</div>
        </div>
    </>
  )
}

export default User_Profile_Com